module.exports = __webpack_public_path__ + "img/pos5-tit.f8d13324.png";